// 站点语言固定为英文
import languages from "./languages.js";

const currentLanguage = "en";

export function translatePage() {
  const elements = document.querySelectorAll("[data-i18n]");

  elements.forEach((element) => {
    const key = element.getAttribute("data-i18n");
    const translation = languages[currentLanguage][key];

    if (translation) {
      // 处理包含HTML标签的翻译
      if (/<\/?[a-z][\s\S]*>/i.test(translation)) {
        translateWithHtml(element, translation);
      }
      // 处理属性翻译
      else if (element.hasAttribute("data-i18n-attr")) {
        const attrs = element.getAttribute("data-i18n-attr").split(",");
        attrs.forEach((attr) => {
          element.setAttribute(attr.trim(), translation);
        });
      }
      // 默认处理文本内容
      else if (element.textContent !== translation) {
        element.textContent = translation;
      }
    }
  });
}

/**
 * 处理带HTML标签的翻译，保留原有结构
 * @param {HTMLElement} element - 要翻译的元素
 * @param {string} html - 包含HTML的翻译文本
 */
function translateWithHtml(element, html) {
  // 保存原始元素的class和属性
  const originalClasses = element.className;
  const originalAttributes = {};
  Array.from(element.attributes).forEach((attr) => {
    if (attr.name !== "data-i18n") {
      originalAttributes[attr.name] = attr.value;
    }
  });

  // 创建临时容器来解析翻译后的HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  // 已经是目标内容则跳过，避免触发 MutationObserver 死循环
  if (element.innerHTML === tempDiv.innerHTML) {
    return;
  }

  // 清空原元素但保留属性和class
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }

  // 添加翻译后的内容
  Array.from(tempDiv.childNodes).forEach((node) => {
    element.appendChild(node.cloneNode(true));
  });

  // 恢复原始class和属性
  element.className = originalClasses;
  Object.entries(originalAttributes).forEach(([name, value]) => {
    element.setAttribute(name, value);
  });
}

// 页头/页脚等要等接口返回后才渲染，DOM 出现的时机不可控，
// 因此监听 DOM 变化，新出现的 data-i18n 元素立即翻译
let scheduled = false;
function scheduleTranslate() {
  if (scheduled) return;
  scheduled = true;
  setTimeout(() => {
    scheduled = false;
    translatePage();
  }, 0);
}

document.addEventListener("DOMContentLoaded", () => {
  document.documentElement.lang = currentLanguage;
  translatePage();
  if (typeof MutationObserver !== "undefined") {
    new MutationObserver(scheduleTranslate).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
});



// WEBPACK FOOTER //
// ./src/assets/js/languages/change_language.js